export enum StepIndicatorDimensions {
	StepIndicatorWidthDesktop = 1280,
	StepIndicatorHeightDesktop = 900,
}
